<app-common-modal #editOptionCategoryModal [name]="'addOption'" [title]=" " [twoButtonsDialogs]="true"
                  [withFooter]="false">
  <h4 modal-title class="modal-title" translate>T_OFFER_DATA_MANAGEMENT_OPTION_INFORMATION</h4>
  <div modal-body>

    <h5 translate>T_CATEGORY_NAME</h5>
    <div class="edit-option-name" *ngFor="let item of editOptionCategoryForm.value | keyvalue; trackBy: trackByFn">
      <span class="edit-option-name-label">{{ item.key }}:</span>
      <input class="edit-option-name-input" type="text" [(ngModel)]="editOptionCategoryForm.value[item.key]"/>
    </div>

    <div class="category-id">
      <span class="category-id-label" translate>id : </span>
      <span class="category-id-value">{{selectedCategoryId}}</span>
    </div>
    <div class="warning-message">
      <label *ngIf="impactedReferences.length == 1" translate>T_ODM_CATEGORY_MODIFICATION_WARNING_REFERENCE</label>
      <label *ngIf="impactedReferences.length > 1" translate>T_ODM_CATEGORY_MODIFICATION_WARNING_REFERENCES</label>
      {{ impactedReferences }}
    </div>
    <div class="edit-option-modal-footer">
      <button class="btn btn-default-white-background" (click)="hide()" translate>T_BUTTON_CANCEL</button>
      <button class="btn btn-default-white-background" [disabled]="!isValidForm()" (click)="clickOnSaveOption(); hide()"
              translate>T_OFFER_DATA_MANAGEMENT_SAVE_OPTION_BUTTON
      </button>
    </div>
  </div>

</app-common-modal>
